(function () {
    'use strict';

    angular
        .module('vcuser.vcuser')
        .config(config);

    config.$inject = ['$stateProvider', '$logProvider'];

    function config($stateProvider, $log) {
        $stateProvider
            .state('playground.vcuseruser', {
                url: '/vcuseruser',
                views: {
                    'playgroundmain@playground': {
                        template: `
              <h3 class="alert alert-info"><tt>&lt;usersearch user="" userref="" editinplace="true"&gt;</tt></h3><div ui-view="usersearchview"></div>
              <h3 class="alert alert-info"><tt>&lt;usersearch user="" userref="" parentsave=""&gt;</tt></h3><div ui-view="usersearchview2"></div>
              <h3 class="alert alert-info"><tt>&lt;usereditor user="" mode="" onClose=""&gt;</tt></h3><div ui-view="usereditview"></div>
              <h3 class="alert alert-info"><tt>&lt;usernew&gt;</tt></h3><div ui-view="usernewview"></div>
              <h3 class="alert alert-info"><tt>&lt;userlist users="?"&gt;</tt></h3><div ui-view="userlistview"></div>
            `
                    }
                },
                onEnter: function ($log) {
                    $log.debug('debug/routes - playground.vcuservcuser entered');
                }
            });


        $stateProvider
            .state('playground.vcuseruser.allcomponents', {
                url: '/allcomponents',
                resolve: {
                    user: function () {
                        return '';
                    },
                    userref: function () {
                        return '';
                    },
                  roles: function () {
                        return [
                          {role: 'tech', label:'Techniker'},
                          {role: 'extern', label:'Externer Mitabeiter'},
                          {role: 'admin', label:'Administrator'}
                        ];
                  },
                    someuser: ['User', function (User) {
                        return User.$find('5980850517c1652dc7195b2f');
                    }],
                    allusers: ['User', function (User) {
                        return User.$search({active: true});
                    }],
                    parentsavesearch: function () {
                        return function (user, userref) {
                            console.log('debug: dummy parentsave called for usersearch with: ', user, userref);
                        };
                    },
                    eip: function () {
                        return true;
                    }
                },
                views: {
                    // When `fooState.barState` is active, `fooComponent`
                    // is loaded into the <ui-view name='content' />
                    // which was created by `fooState`.
                    // The component's `foo` input receives `fooData` resolve
                    'usersearchview@playground.vcuseruser': {
                        component: 'usersearch',
                        bindings: {
                            user: 'user',
                            userref: 'userref',
                            editinplace: 'eip'
                        }
                    },
                    'usersearchview2@playground.vcuseruser': {
                        component: 'usersearch',
                        bindings: {
                            user: 'user',
                            userref: 'userref',
                            parentsave: 'parentsavesearch'
                        }
                    },
                    'usereditview@playground.vcuseruser': {
                        component: 'usereditor',
                        bindings: {
                            user: 'someuser'
                        }
                    },
                    'usernewview@playground.vcuseruser': {
                        component: 'usernew',
                        bindings: {}
                    },
                    'userlistview@playground.vcuseruser': {
                        component: 'userlist',
                        bindings: {
                            users: 'allusers'
                        }
                    }
                },
                onEnter: function () {
                    console.log('playground.vcuseruser.allcomponents entered');
                }
            });


    }// all routes


}());






